export enum LookupsEnum {
  Companies = 'LDC',
  States = 'State',
  BcaStatus = 'BcaStatus',
  DevelopmentStatus = 'DevelopmentStatus',
  ProjectTypes = 'ProjectType',
  ContactTypes = 'ContactType',
  GasQuestionnaires = 'Gas_Questionnaire_LKP',
  GasRequestType = 'GasRequestTypeCodeLookup',
  GasRequestTypeBcaCode = 'GasRequestType',
  ConstructionStatus = 'ConstructionStatus',
  GasRequestStatus = 'GasRequestStatusLookup',
  DevelopmentStreetType = 'DevelopmentStreetTypeLookup',
  UtilityEasementType = 'UtilityEasement',
  ServiceCenter = 'ServiceCenter',
  BannerMessages = 'BannerMessages',
  Direction = 'Direction',

  BCAType = 'BCAType',
  LoadType = 'LoadType',
  BuildingType = 'BuildingType',
  DeliveryPressure = 'DeliveryPressure',
  GasLoadMultiplier = 'GasLoadMultiplier',
  DefaultResidentialPressure = 'DefaultResidentialPressure',
  DefaultCommercialPressure = 'DefaultCommercialPressure',

  State = 'State',
  City = 'City',
  County = 'County',
  LocalDistrict = 'LocalDistrict',
  Messages = 'Messages',
  StreetType = 'StreetType',
  MeterExist = 'MeterExist',
  BcaDuplicate = 'BcaDuplicate',

  WorkRequestType = 'WorkRequestType',
  LotStatusType = 'LotStatusTypes',
  MarketerOfChoice = 'MarketerOfChoice',
  ContractRejectTeason= 'ContractRejectReason',
  WRLoadARMLookup = 'WRLoadARMLkp',
}
